import * as ents from '@attain-apps/entities'

export interface State {
  /** @see {@link ents.core.dms.models.Schema} */
  schema: ents.core.dms.models.Schema
  /** Indicates if schema is loading */
  isLoading?: boolean
  /** Indicates if schema loading has encountered an error */
  error?: string | Error
}
export namespace State {
  export const INITIAL: NoMissing<State> = {
    error: undefined,
    isLoading: false,
    schema: new ents.core.dms.models.Schema(),
  }
}
